<div class="wrapper">
  <span>
    @if (params()?.value?.name) {
      <a class="basic-click-cell" (click)="onDispatchEvent($event)">{{ $safeNavigationMigration(params()?.value?.name) | infoDisplay }}</a>
    } @else if (followedVariable()?.name) {
      <a class="basic-click-cell" (click)="onDispatchEvent($event)">{{ $safeNavigationMigration(followedVariable()?.name) | infoDisplay }}</a>
    }
  </span>
</div>
